import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './Header.css';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <>
      <a href="#main-content" className="skip-to-content">Skip to main content</a>

      {/* Top Utility Bar */}
      <div className="top-bar">
        <div className="top-bar-inner">
          <div className="top-bar-left">
            <span>📧 accugen@proautomate.ai</span>
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-inner">

          {/* Brand Logo — image + title + tagline */}
          <Logo
            to="/"
            image="/logo.png"
            imageAlt="AccuGen logo"
            title="AccuGen"
            titleAccent=".ai"
            tagline="Where AI Meets Reality"
            onClick={close}
          />

          <div className={`nav-links${menuOpen ? ' open' : ''}`}>
            <Link to="/"         className={`nav-link${pathname === '/'         ? ' active' : ''}`} onClick={close}>Home</Link>
            <Link to="/about"    className={`nav-link${pathname === '/about'    ? ' active' : ''}`} onClick={close}>About</Link>
            <Link to="/features" className={`nav-link${pathname === '/features' ? ' active' : ''}`} onClick={close}>Features</Link>
            <Link to="/services" className={`nav-link${pathname === '/services' ? ' active' : ''}`} onClick={close}>Services</Link>
            <Link to="/security" className={`nav-link${pathname === '/security' ? ' active' : ''}`} onClick={close}>Security</Link>
            <Link to="/workflow" className={`nav-link${pathname === '/workflow' ? ' active' : ''}`} onClick={close}>Workflow</Link>
            <Link to="/contact"  className={`nav-link${pathname === '/contact'  ? ' active' : ''}`} onClick={close}>Contact</Link>
            <a
              href="/contact"
              className="nav-cta"
              rel="noreferrer"
              onClick={close}
            >
              Reach Us →
            </a>
          </div>

          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>
    </>
  );
}
